import { FC, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setCardToShow } from "../../../reduxToolkit/reducers/layoutSlice";
import { BlogGridViewType } from "../../../types/Blog";
import BlogSidebar from "./blogSidebar";
import BlogBox from "./blogBox";
import TopSlider from "./TopSlider";
import Breadcrumbs from "../breadcrumbs";
import { routes } from "../../../routers/routes";

const BlogGridView: FC<BlogGridViewType> = ({ carShow, side, gridSize, type, sectionClass }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCardToShow(carShow || 9));
  }, [carShow, dispatch]);
  return (
    <>
      <Breadcrumbs title="Blog" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <section className={`blog-grid-section section-b-space ${sectionClass ? sectionClass : ""}`}>
        <Container>
          {type === "top_slider" && <TopSlider />}
          <Row className="custom-row gy-lg-0 gy-4">
            {side !== "no" && (
              <Col lg="3" className={`${side !== "right" ? "order-lg-0" : ""} order-1`}>
                <BlogSidebar socialContact />
              </Col>
            )}
            <div className={side === "no" ? "col-lg-12" : "col-lg-9"}>
              {type === "load_more" ? (
                <div className="featured-wrapper">
                  <BlogBox gridSize={gridSize} type={type} />
                </div>
              ) : (
                <BlogBox gridSize={gridSize} type={type} />
              )}
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BlogGridView;
